
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"currentColor","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24zm0-3C12.402 45 3 35.598 3 24S12.402 3 24 3s21 9.402 21 21-9.402 21-21 21z","fill-rule":"nonzero"}}),_c('path',{attrs:{"d":"M12 31h24a1.5 1.5 0 000-3H12a1.5 1.5 0 000 3z","fill-rule":"nonzero"}}),_c('circle',{attrs:{"cx":"16.5","cy":"17.5","r":"2.5"}}),_c('circle',{attrs:{"cx":"31.5","cy":"17.5","r":"2.5"}})])])
          )
        }
      }
    